import { useMemo } from "react";
import { object, string } from "yup";


export type VerificationMail = {
  email: string;
};

const useValidationSchemaMail = () => {
  return useMemo(() => {
    const requiredEmailMessage = "form.error.notEmpty";
    const invalidEmailMessage = "form.error.emailInvalid";

    // Schema représentant l'ensemble des champs du formulaire
    // inclu la validation de ces champs si nécessaire
    const validationSchema = object<VerificationMail>().shape({
      email: string().email(invalidEmailMessage).required(requiredEmailMessage),
    });
    return validationSchema;
  }, []);
};

export default useValidationSchemaMail;
